/**
 * <ProgramMixBar> — ce dont un programme de stage est fait, en une barre (molecule).
 *
 * Pendant l'année, un stage mêle les bases de la classe d'avant et le début de la classe de
 * l'élève, dans une part fixée : la barre le montre d'un coup d'œil, à la place d'une phrase.
 * Les bases sont l'aplat clair, la classe de l'élève le marine.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { SegmentedBar } from "../../atoms/SegmentedBar"
import { Text } from "../../atoms/typography/Text"
import { type UIStageProgramMix } from "../../../ports/primary/ui/types"

export type ProgramMixBarProps = {
    mix: UIStageProgramMix
    testID?: string
}

export function ProgramMixBar(props: ProgramMixBarProps) {
    const { mix, testID } = props

    return (
        <Stack gap="1" testID={testID}>
            <SegmentedBar
                segments={[
                    { value: mix.previous, color: "border" },
                    { value: mix.own, color: "primary" },
                ]}
                max={mix.previous + mix.own}
                height={8}
            />
            <Row justify="between" style={styles.labels}>
                <Text size="text-sm" color="text-muted">
                    {mix.previousLabel}
                </Text>
                <Text size="text-sm" color="text-muted">
                    {mix.ownLabel}
                </Text>
            </Row>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    labels: {
        flexWrap: "wrap",
    },
}))
